import { smartPushState } from '../vendor/evented-history-state-functions';
import { getUrlArray } from '../vendor/url-helper-functions';

const glossaryWrapper = document.querySelector(".glossary-wrapper");

// Only run if glossary wrapper exists
if (glossaryWrapper) {
	const glossaryTabs = glossaryWrapper.querySelectorAll(".glossary-tab");
	const glossaryNavs = document.querySelectorAll(".glossary-nav");
	const glossaryNavLinks = document.querySelectorAll(".glossary-nav a");

	if (glossaryNavs.length > 0) {
		glossaryNavLinks.forEach(link => {
			link.addEventListener("click", function(event) {
				event.preventDefault();
				const thisLink = event.target;
				const href = thisLink.getAttribute("href");
				const selectedAlpha = thisLink.dataset.alpha;

				// Update URL using the same logic as Q&A
				smartPushState("alpha", selectedAlpha);

				glossaryTabs.forEach(tab => {
					tab.classList.add("is-hidden");
				});
				glossaryWrapper.querySelector("." + href).classList.remove("is-hidden");

				// Update both top and bottom navigation
				glossaryNavLinks.forEach(navLink => {
					navLink.classList.remove("is-active");
				});
				document.querySelectorAll(".glossary-nav a[data-alpha='" + selectedAlpha +"']").forEach(link => {
					link.classList.add("is-active");
				});

				if (thisLink.parentElement.classList.contains("bottom")) {
					window.scrollTo({
						top: document.querySelector("#glossary-scroll").offsetTop - 100,
						behavior: "smooth"
					});
				}
			});
		});

		// Check URL on page load
		const urlArray = getUrlArray();
		const alphaFilter = urlArray[4]; // Get the alpha segment from URL

		if (alphaFilter && alphaFilter !== 'glossary') {
			// Find and click the appropriate link based on URL parameter
			const targetLink = document.querySelector(`.glossary-nav a[data-alpha="${alphaFilter}"]`);
			if (targetLink) {
				targetLink.click();
			} else {
				// Default to first link if no valid parameter
				const defaultLink = document.querySelector(".glossary-nav .display-on-load");
				if (defaultLink) {
					defaultLink.click();
				}
			}
		} else {
			// Default behavior
			const defaultLink = document.querySelector(".glossary-nav .display-on-load");
			if (defaultLink) {
				defaultLink.click();
			}
		}
	}
}

export function filterGlossary(filterby, filter, slug) {
	const glossaryWrapper = document.querySelector(".glossary-wrapper");

	if (!glossaryWrapper) {
		return; // Exit if glossary wrapper doesn't exist
	}

	const glossaryTabs = glossaryWrapper.querySelectorAll(".glossary-tab");
	const glossaryNavLinks = document.querySelectorAll(".glossary-nav a");

	if (!filter) {
		filter = "a-e";
	}

	// Activate filter for both top and bottom navigation
	glossaryNavLinks.forEach(navLink => {
		navLink.classList.remove("is-active");
	});

	document.querySelectorAll(`.glossary-nav a[data-alpha="${filter}"]`).forEach(link => {
		link.classList.add("is-active");
	});

	// Filter glossary tabs
	glossaryTabs.forEach(tab => {
		tab.classList.add("is-hidden");
	});

	const targetTab = glossaryWrapper.querySelector("." + filter);
	if (targetTab) {
		targetTab.classList.remove("is-hidden");
	}
}
